import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { TenantApiService } from '../http/tenant-api.service';
import { TenantSelfHostedIrt } from 'src/app/shared/models/tenant-irt';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class TenantSelfHostedIrtService {
    constructor(private tenantApiService: TenantApiService) {}

    getTenantSelfHostedIrts(tenantId: string): Observable<TenantSelfHostedIrt[]> {
        return this.tenantApiService.getTenantSelfHostedIrts(tenantId).pipe(
            catchError((errorResponse: HttpErrorResponse) => {
                return throwError(() => errorResponse);
            })
        );
    }
}
